import { useEffect, useRef } from 'react'
import { postToTikTokPlayer, TIKTOK_ORIGIN } from './socialCarouselCards'

const VISIBILITY_THRESHOLD = 0.2

let installed = false
const tiktokHandles = new Set()

const isTikTokPlayingState = (value) => Number(value) === 1

const pauseUnmutedVideos = (except) => {
  document.querySelectorAll('video').forEach((video) => {
    if (video === except || video.muted || video.paused) return
    video.pause()
  })
}

const pauseTikTokHandles = (except) => {
  tiktokHandles.forEach((handle) => {
    if (handle === except) return
    handle.pause()
  })
}

const onNativePlay = (event) => {
  const target = event.target
  if (!(target instanceof HTMLVideoElement)) return
  if (target.muted) return
  pauseUnmutedVideos(target)
  pauseTikTokHandles(null)
}

const onTikTokMessage = (event) => {
  if (event.origin !== TIKTOK_ORIGIN) return
  if (!event.data?.['x-tiktok-player']) return

  const handle = [...tiktokHandles].find((entry) => entry.iframe.contentWindow === event.source)
  if (!handle) return

  if (event.data.type === 'onStateChange' && isTikTokPlayingState(event.data.value)) {
    pauseUnmutedVideos(null)
    pauseTikTokHandles(handle)
  }
}

const install = () => {
  if (installed || typeof document === 'undefined') return
  installed = true
  document.addEventListener('play', onNativePlay, true)
  window.addEventListener('message', onTikTokMessage)
}

install()

export const registerTikTokPlayer = (iframe) => {
  install()
  if (!iframe) return () => {}

  const handle = {
    iframe,
    pause: () => postToTikTokPlayer(iframe, 'pause'),
  }
  tiktokHandles.add(handle)
  return () => {
    tiktokHandles.delete(handle)
  }
}

export const usePausePlayerOffscreen = (targetRef, pause, enabled) => {
  const pauseRef = useRef(pause)
  pauseRef.current = pause

  useEffect(() => {
    if (!enabled) return undefined

    const target = targetRef.current
    if (!target || typeof IntersectionObserver === 'undefined') return undefined

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio < VISIBILITY_THRESHOLD) pauseRef.current()
        })
      },
      {
        threshold: [0, VISIBILITY_THRESHOLD],
        root: target.closest('.site-main-scroll'),
      }
    )

    observer.observe(target)
    return () => observer.disconnect()
  }, [targetRef, enabled])
}
